import Label from "lib/Label";
import { Image } from "lib";
import show_password from "assets/images/show_password.svg";
import hide_password from "assets/images/hide_password.svg";
import { Col } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { convertNumberToWord } from "helper/convertNumberToWord";
import { calculateNetAssets ,calculateGrandTotal } from "helper/calculateNetAsset";
import {mergeFields} from "helper/triggerButtonCallback"
import {
  addValueToAssets,
  setSelectedData,
  setTotalAssets,
  setTotalNetValue,
  setCalculatedValue,
  setFinancialDetails,
  addValueToNetAssets,
  setTotalNetAssestsValue,
  assignValueToKey,
} from "redux/formDisplay";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { fetchAddressDataFromPincode } from "api/formDisplay";
import Toast from "components/ToastComponent";
import { assignPoc } from "helper/userHierarchy";

// import { IndirectEval } from 'helper/indirectEval';
const Number = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    events,
    name,
    disabled,
    error,
    size,
    className,
    tooltip,
    isEditable,
    is_disabled,
    selectedData,
    validators,
    onBlur,
    onLoad,
    default_value,
    fetch_pincode_details, // * If this is true only then the details will be fetched based on pincode
    autofill, // * If pincode details are fetch the based on this the details will be auto filled
    number_length,// * This is the length of the pincode
    assign_poc,  //  *If this is true then based on the value of this field poc will be assigned
    fetch_reporting_manager, // If this is true than reporting manger of the pocs will be fetched
    hierarchy_required,
    masking_type,
    type
  } = props;

  const [newType,setType] = useState(type)
  const [fieldName, setFieldName] = useState("");
  const [fieldItem, setFieldItem] = useState("");
  const [financial, setFinancial] = useState("");
  const [assetFieldName, setAssetFieldName] = useState("");
  const [totalAssetName, setTotalAssets] = useState("");
  const [loading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const tableListingData = useSelector(state => state.dashboardReducer.tableListingData);
  const [dashboardTableListingData, setDashboardTableListingData] = useState(tableListingData);
  const subWfId = useSelector((state) => state.urlEncryption?.urlId?.subWfId);
  const [internalPOCUpdatedSuccessfully, setInternalPOCUpdatedSuccessfully] =useState(false);

  const data = useSelector((state) => state?.formData?.selectedData);
  const netAssetsKeyValue = useSelector(
    (state) => state?.formData?.netAssetsKeyValue
  );
  const finalAssetsNetValue = useSelector(
    (state) => state?.formData?.finalAssetsNetValue
  );
  const assetsKeys = useSelector((state) => state?.formData?.assetsKeyValue);
  const totalNetValue = useSelector((state) => state?.formData?.totalNetValue);
  const calculatedValue = useSelector(
    (state) => state?.formData?.calculatedValue
  );
  const financialDetails = useSelector(
    (state) => state?.formData?.financialDetails
  );
  const organisationId = useSelector(state => state?.configurationReducer?.config?.organisation_id)
  var totalValue;
  var netIncome;
  var financialValue;
  var netAssets, totalnetAssets;
  const dispatch = useDispatch();
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  var result;
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const fetchAndProcessAddressDetails = async () => {
    setIsLoading(true)
    const response = await fetchAddressDataFromPincode({
      "source" : value,
      "organisation_id" : organisationId
    });

    // * By default taking the first response because there might be - 
    // * - multiple post offices under one pincode
    const addressDetails = response?.data?.addressDetails?.[0];

    // * If address details are found then auto-filling
    if(addressDetails && autofill) {
      autofill?.map(item => {
        dispatch(setSelectedData({
          key: [`${item?.destination_field}`],
          value: addressDetails?.[`${item?.source_field}`],
        }))
      })
    } 
    setIsLoading(false);
    if(response?.status?.toLowerCase() == "success"){
      setMessageToast({type: "success",msg: response?.message ? response?.message : "Data extracted successfully"});
          setTimeout(() => {
              setMessageToast(null);
          }, 2000); 
    }
    else{
      
        dispatch(setSelectedData({ key: name, value: "" }));
        const errorMessage = response?.message ? response?.message : "Data not extracted successfully";
        setMessageToast({type: "error",msg: errorMessage});
        setTimeout(() => {
          setMessageToast(null);
        }, 2000);
    }
  }

  const onKeyUpCapture = async (item) => {
    /**
     ** If fetch_pincode_details key is true and the value is 6 chars long
     ** only in that case the pincode API will be called  
     */
    if(fetch_pincode_details && value?.length === number_length) {
      fetchAndProcessAddressDetails()
    }
    if(assign_poc && value?.length === number_length ){
      let obj = {
        wf_configuration_id: selectedData?.configuration_id,
        custom_filters: {
          [name] : selectedData[name]
          },
      };
      let paramObj = {
        customKeys : obj,
        selectedData :selectedData,
        workflowId :subWfId,
        fetchReportingManager : eval(fetch_reporting_manager),
        hierarchy_required: hierarchy_required
      } 
      let result = await assignPoc(paramObj,dispatch,dashboardTableListingData,setDashboardTableListingData,setInternalPOCUpdatedSuccessfully)  
    }
    if (events) {
      IndirectEval(events?.onKeyUpCapture);
    }
  };
  const concatenateFields =  (data,extractedData,keyName) =>{
    mergeFields(data,extractedData,keyName,dispatch,setSelectedData)
  }
  const calculateNetAsset = async (id, operator, item) => {
    setAssetFieldName(item);
    dispatch(
      addValueToNetAssets({
        fieldName: id,
        fieldValue: { value: data[id], operator: operator },
      })
    );
  };
  const calculateFinalNetAsset = async (id, operator, item) => {
    setTotalAssets(item);
    dispatch(
      setTotalNetAssestsValue({
        fieldName: id,
        fieldValue: { value: data[id], operator: operator },
      })
    );
  };
  const calculateTheTotal = async (add, subtract, netField, totalField,multiply) => {
    calculateGrandTotal(add, subtract, netField, totalField, data, dispatch, assignValueToKey,multiply)
    }  ;
   const calculateFinancialDetails = async (id, operator, item) => {
    setFinancial(item);
    dispatch(
      setFinancialDetails({
        fieldName: id,
        fieldValue: { value: data[id], operator: operator },
      })
    );
  };
  
  const calculateDataValue = async (formulas, totalField , maxDecimalNumber) => {
  formulas?.forEach((calculatedValue,index) => {
    if(maxDecimalNumber){
    calculatedValue = calculatedValue?.toFixed(maxDecimalNumber[index])
    }
   dispatch(setSelectedData({ key: totalField[index], value: calculatedValue?.toString() }))
   });
  };

  const calculateNetValue = async (id, operator, item) => {
    setFieldItem(item);
    dispatch(
      setTotalNetValue({
        fieldName: id,
        fieldValue: { value: data[id], operator: operator },
      })
    );
  };
  useEffect(() => {
    totalValue = calculateNetAssets(assetsKeys);
    if (totalValue) {
      dispatch(setCalculatedValue(totalValue));
    }
    dispatch(
      setTotalNetValue({
        fieldName: "calculated_value",
        fieldValue: { value: totalValue, operator: "+" },
      })
    );
    dispatch(setSelectedData({ key: fieldName, value: totalValue }));
  }, [assetsKeys]);
  useEffect(() => {
    netIncome = calculateNetAssets(totalNetValue);
    dispatch(setSelectedData({ key: fieldItem, value: netIncome }));
  }, [totalNetValue]);

  useEffect(() => {
    financialValue = calculateNetAssets(financialDetails);
    dispatch(setSelectedData({ key: financial, value: financialValue }));
  }, [financialDetails]);

  useEffect(() => {
    netAssets = calculateNetAssets(netAssetsKeyValue);
    netAssets= parseFloat(netAssets).toFixed(2);
    dispatch(
      setTotalNetAssestsValue({
        fieldName: "calculated_value",
        fieldValue: { value: netAssets, operator: "+" },
      })
    );
  
    dispatch(setSelectedData({ key: assetFieldName, value: netAssets }));
  }, [netAssetsKeyValue]);
  useEffect(() => {
    totalnetAssets = calculateNetAssets(finalAssetsNetValue);
    totalnetAssets= parseFloat(totalnetAssets).toFixed(2);
    dispatch(setSelectedData({ key: totalAssetName, value: totalnetAssets }));
  }, [finalAssetsNetValue]);

 
  const numberToWords = async (item) => {
    result = await convertNumberToWord(value);
    dispatch(setSelectedData({ key: item, value: result }));
    return item;
  };

  const evalBasedOnDisabledLogic = (item) => {
    if (is_disabled) {
      // split at . and then check if the first part is present in selectedData
      let stateTocheck = item.split(".")[1];
      if (
        selectedData &&
        selectedData[stateTocheck] &&
        selectedData[stateTocheck] !== undefined &&
        selectedData[stateTocheck] !== null
      ) {
        if (eval(is_disabled)) {
          return true;
        }
      } else {
        return false;
      }
    }
  };
  useEffect(() => {
    if (default_value && !selectedData[name]) {
      onLoad(name, default_value);
    }
  }, []);

  useEffect(() => {
    if (masking_type) {
      setType(masking_type);
    }
  }, [masking_type]);

  const togglePassword =()=>{
    if(newType == masking_type)
    {
      setType("text")
     return;
    }
    setType(masking_type)
  }

  const handleCloseToast = () => {
    setInternalPOCUpdatedSuccessfully(false);
  };

  return (
    <div className={size}>
         {internalPOCUpdatedSuccessfully && (
                      <Toast
                          // onClose setInternalPOCUpdatedSuccessfully to false and show toast for 3 seconds
                          onClose={() => handleCloseToast}
                          message="Internal POC updated successfully!"
                          type="success"
                          autoClose={2000}
                      />
                  )}

       {messageToast?.msg && (
        <Toast message={messageToast?.msg} type={messageToast?.type} />
      )}
      {label ? (
        <Label label={label} tooltip={tooltip} validators={validators} />
      ) : null}
      {!loading ? (
        <div className="position-relative">
        <input
          type={masking_type ? newType : "text"}
          name={name}
          className={`form-input ${errorClass} ${
            !isEditable && "radioDisabled"
          }`}
          placeholder={placeholder}
          value={value ? value : ""}
          onChange={onChange}
          onBlur={onBlur}
          onKeyUpCapture={onKeyUpCapture}
          disabled={
            selectedData &&
            is_disabled &&
            //  && is_disabled!== undefined
            evalBasedOnDisabledLogic(is_disabled)
              ? true
              : disabled
              ? disabled
              : isEditable
              ? false
              : true
          }
        />
         {masking_type && (
          <Image
            className="position-absolute top-50 end-0 translate-middle"
            imageSrc={newType === "password" ? show_password : hide_password}
            onClick={togglePassword}
          />
        )}
        </div>
      ) : (
        <div className="position-relative">
          <input
            // type={type}
            name={name}
            className={`form-input form-input-spinner`}
            placeholder={placeholder}
            value={value}
          />
          <div class="spin-loader position-absolute">Loading...</div>
        </div>
      )}

      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>
  );
};

export default Number;



